export default __webpack_public_path__ + "static/media/docx.7c691377.webp";